<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part-title" id="pt-2"><strong><em><a id="_idTextAnchor006">Commentary</a></em></strong></h1><a id="_idTextAnchor006">
<p class="imaged"><img alt="Image" src="images/dline.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 009_Commentry.vue?0deca30e